export default "__VITE_ASSET__d7e79d5f__"